import { render, staticRenderFns } from "./SysUserAgentModal.vue?vue&type=template&id=2d35e8c8&scoped=true"
import script from "./SysUserAgentModal.vue?vue&type=script&lang=js"
export * from "./SysUserAgentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d35e8c8",
  null
  
)

export default component.exports